import React from 'react';
import './style.scss';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
// import MenuIcon from '@material-ui/icons/Menu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AddIcon from '@material-ui/icons/Add';
import Remove from '@material-ui/icons/Remove';
import SyncIcon from '@material-ui/icons/Sync';
import { faDatabase } from '@fortawesome/free-solid-svg-icons'
// import SearchIcon from '@material-ui/icons/Search';
// import MoreIcon from '@material-ui/icons/MoreVert';
// import 'react-leaflet-fullscreen/dist/styles.css'
// import FullscreenControl from 'react-leaflet-fullscreen';

const useStyles = makeStyles((theme) => ({
    appBar: {
        top: 'auto',
        bottom: 0,
        height: "55px",
        backgroundColor: "#121E2C"
    },
    grow: {
        flexGrow: 1,
    },
    zoomFabButtons: {
        position: 'absolute',
        zIndex: 1,
        top: -30,
        left: 0,
        right: 0,
        margin: '0 auto'
    },
    icon: {
        color: "#fff"
    },
    fabAdd: {
        marginLeft: "15px",
    },
    iconBtn: {
        padding: "15px",
        alignSelf: "flexStart"
    }
}));
export default function ControlLayer(props) {
    const { changeZoomLevel, resetMap } = props;
    const classes = useStyles();
    return (
        <AppBar position="fixed" className={classes.appBar}>
            <Toolbar>
                <IconButton onClick={() => props.setDataMenuStatus(!props.isDataMenuOpen)} edge="start" className="iconBtn" aria-label="open drawer">
                    <FontAwesomeIcon color="#fff" size="1x" icon={faDatabase} />
                </IconButton>
                <div className={classes.zoomFabButtons}>
                    <Fab onClick={() => { changeZoomLevel("out"); }} aria-label="add" className={classes.fabRemove}>
                        <Remove />
                    </Fab>
                    <Fab onClick={() => { changeZoomLevel("in") }} aria-label="remove" className={classes.fabAdd}>
                        <AddIcon />
                    </Fab>
                </div>
                <div className={classes.grow} />
                <IconButton className="iconBtn">
                    {/* <SearchIcon className={classes.icon} /> */}
                </IconButton>
                <IconButton className="iconBtn" onClick={() => resetMap()} edge="end" >
                    <SyncIcon fontSize="large" className={classes.icon} />
                </IconButton>

                {/* <div style={{ zIndex: 9999, position: "fixed", left: 10, color: "transparent", top: 80 }}>
                <button onClick={() => props.resetMap()} className="controlActionBtn" >
                    <FontAwesomeIcon size="lg" icon={faSync} />
                </button>
            </div> */}


            </Toolbar>
            {/* <FullscreenControl position="topright" /> */}
        </AppBar>
    );
}